module.exports = __webpack_public_path__ + "media/banks/apply-pay-f7d6a5f1.png";